module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-duedate-month-1-99e90d12f1bd9fdf785bea87ed46ad59.svg";